import { render, staticRenderFns } from "./FooterButton.vue?vue&type=template&id=ac9b6bf4&"
import script from "./FooterButton.vue?vue&type=script&lang=ts&"
export * from "./FooterButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports